// extracted by mini-css-extract-plugin
export default {"container":"organization-list_container__WNzfv","header":"organization-list_header__b8OuE","ngoImage":"organization-list_ngoImage__7Dtai"};